document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  const MQ = window.matchMedia('(min-width: 768px)');
  const sections = document.querySelectorAll('.section-recruitment-process');

  // Per-section state
  const state = new WeakMap();

  function enable(section) {
    const header   = section.querySelector('.section-recruitment-process__header');
    const viewport = section.querySelector('.section-recruitment-process__steps');
    const wrapper  = section.querySelector('.section-recruitment-process__steps_wrapper');
    const steps    = section.querySelectorAll('.recruitment-step');
    if (!viewport || !wrapper || !steps.length) return;

    // keep header locked to section padding
    const padTop = parseFloat(getComputedStyle(section).paddingTop) || 0;
    if (header) header.style.top = padTop + 'px';

    let st; // ScrollTrigger instance

    const measure = () => {
      const vh = viewport.clientHeight;
      const contentH = wrapper.scrollHeight;
      const totalShift = Math.max(0, contentH - vh);
      return { totalShift };
    };

    const build = () => {
      const { totalShift } = measure();
      if (st) st.kill();
      gsap.set(wrapper, { y: 0 });

      if (totalShift <= 1) return;

      const startFn = () => (ScrollTrigger.direction >= 0 ? 'bottom bottom' : 'top top+=0');

      st = ScrollTrigger.create({
        trigger: section,
        start: startFn,
        end: () => '+=' + measure().totalShift,
        pin: true,
        pinSpacing: true,
        scrub: 0.18,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onUpdate: self => {
          gsap.to(wrapper, { y: -self.progress * measure().totalShift, duration: 0, overwrite: 'auto' });
        },
        onEnter:     () => ScrollTrigger.removeEventListener('refreshInit', refreshOnDirChange),
        onEnterBack: () => ScrollTrigger.removeEventListener('refreshInit', refreshOnDirChange),
        onLeave:     () => ScrollTrigger.addEventListener('refreshInit', refreshOnDirChange),
        onLeaveBack: () => ScrollTrigger.addEventListener('refreshInit', refreshOnDirChange),
      });

      function refreshOnDirChange() {
        if (!st.isActive) st.vars.start = startFn;
      }
      ScrollTrigger.addEventListener('refreshInit', refreshOnDirChange);

      const resizeH = () => ScrollTrigger.refresh();
      window.addEventListener('resize', resizeH);
      window.addEventListener('load', resizeH, { once: true });

      state.set(section, { st, resizeH, refreshOnDirChange, header, wrapper });
    };

    build();
  }

  function disable(section) {
    const s = state.get(section);
    const header   = section.querySelector('.section-recruitment-process__header');
    const wrapper  = section.querySelector('.section-recruitment-process__steps_wrapper');

    if (s?.st) {
      ScrollTrigger.removeEventListener('refreshInit', s.refreshOnDirChange);
      s.st.kill();
    }
    if (s?.resizeH) {
      window.removeEventListener('resize', s.resizeH);
    }

    // Clear inline styles so layout returns to normal
    if (wrapper) gsap.set(wrapper, { clearProps: 'transform' });
    if (header)  header.style.top = '';

    state.delete(section);
  }

  function applyMode(matches) {
    sections.forEach(sec => (matches ? enable(sec) : disable(sec)));
  }

  // Initial + on change
  applyMode(MQ.matches);
  MQ.addEventListener ? MQ.addEventListener('change', e => applyMode(e.matches))
                      : MQ.addListener(e => applyMode(e.matches)); // Safari fallback
});
